import React, { Component } from 'react';
import TableList from 'components/TableList';
import pickBy from 'lodash/pickBy';
import queryString from 'query-string';
import { AppSettings } from '../../constants';
import isEqual from 'lodash/isEqual';
import {
  initialSizePerPage,
  dispatchActionSetPageSizeReference
} from 'helper/unit-helper';
// import * as DashBoardActionType from '../constants';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
const defaultParams = {
  defaultSortName: 'refNo',
  defaultSortOrder: 'ascending',
  sizePerPage: 10
};

const TABLE_NAME = 'NEW_REQUEST_FROM_HOMEOWNER_LIST';
class NewRequestFromHomeownerTable extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    DashBoardStore: PropTypes.object,
    location: PropTypes.object,
    PageSizeReference: PropTypes.object,
    history: PropTypes.object,
    loading: PropTypes.bool,
    getNewRequestList: PropTypes.func
  };
  constructor(props) {
    super(props);

    this.sizePerPage = initialSizePerPage(
      TABLE_NAME,
      props.PageSizeReference,
      props.DashBoardStore.NewRequestDashBoardList.params.take
    );

    this.queryParams = queryString.parse(this.props.location.search);
    this.state = {
      sizePerPage: this.queryParams.take
        ? Number(this.queryParams.take)
        : this.sizePerPage,
      currentPage: this.queryParams.page
        ? Number(this.queryParams.page)
        : props.DashBoardStore.NewRequestDashBoardList.params.page,
      totalRecord: props.DashBoardStore.NewRequestDashBoardList.params.total,
      defaultSortName: this.queryParams.sortField
        ? this.queryParams.sortField
        : defaultParams.defaultSortName,
      defaultSortOrder: this.queryParams.sortOrder
        ? this.queryParams.sortOrder
        : defaultParams.defaultSortOrder,
      searchTxt: this.queryParams.searchKey || '',
      isDisplayTable: true,
      isLoading: this.props.loading,
      column: [
        {
          field: 'refNo',
          header: 'RFS#',
          hidden: false,
          isKey: true,
          sort: true,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'name',
          customRender: this.customRenderRFS.bind(this)
        },
        {
          field: 'lotName',
          header: 'Lot#',
          hidden: false,
          isKey: false,
          sort: false,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'name'
        },
        {
          field: 'streetAddress',
          header: 'Street Address',
          hidden: false,
          isKey: false,
          sort: false,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'address'
        }
      ]
    };
  }

  componentDidMount() {
    if (this.queryParams.page) {
      this.fetchNewRequestList({
        ...this.queryParams,
        page: this.queryParams.page
      });
    } else {
      this.fetchNewRequestList({
        take: this.state.sizePerPage
        //list filter for future integrate
      });
    }

    if (this.queryParams.take) {
      dispatchActionSetPageSizeReference(
        this.props.dispatch,
        TABLE_NAME,
        Number(this.queryParams.take)
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    const urlParams = queryString.parse(nextProps.location.search);

    if (nextProps.DashBoardStore && nextProps.DashBoardStore.NewRequestDashBoardList) {
      this.setState({
        totalRecord: nextProps.DashBoardStore.NewRequestDashBoardList.params.totalRecord,
        currentPage: Number(nextProps.DashBoardStore.NewRequestDashBoardList.params.page)
      });
      let pagingButtons = document.getElementsByClassName('page-link');
      Array.prototype.forEach.call(pagingButtons, el => {
        el.blur();
      });
    }

    if (typeof urlParams.searchKey !== 'undefined') {
      this.setState({ searchTxt: urlParams.searchKey });
    } else {
      this.setState({ searchTxt: '' });
    }
    if (!urlParams.page) {
      this.setState({
        defaultSortName: defaultParams.defaultSortName,
        defaultSortOrder: defaultParams.defaultSortOrder
      });
    }

    if (
      urlParams.sortField &&
      urlParams.sortField !== this.state.defaultSortName
    ) {
      this.setState({ defaultSortName: urlParams.sortField });
    }

    if (
      urlParams.sortOrder &&
      urlParams.sortOrder !== this.state.defaultSortOrder
    ) {
      this.setState({ defaultSortOrder: urlParams.sortOrder });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.sizePerPage !== this.state.sizePerPage) {
      dispatchActionSetPageSizeReference(
        this.props.dispatch,
        TABLE_NAME,
        this.state.sizePerPage
      );
    }

    if (
      AppSettings.clientTypeValue === 'Builder' &&
      !isEqual(this.props.location.search, prevProps.location.search)
    ) {
      let urlParams = queryString.parse(this.props.location.search);

      if (urlParams.page) {
        this.fetchNewRequestList({
          ...urlParams,
          page: urlParams.page
        });
      } else {
        this.fetchNewRequestList({
          sortField: defaultParams.defaultSortName,
          sortOrder: defaultParams.defaultSortOrder,
          page: 1,
          take: this.state.sizePerPage
        });
      }
    }
  }

  objToParams = obj => {
    const urlParams = queryString.parse(this.props.location.search);

    return {
      searchKey:
          typeof urlParams.searchKey !== 'undefined'
            ? urlParams.searchKey
            : this.state.searchTxt.trim(),
      sortField: obj.sortField ? obj.sortField : obj.sort.field,
      sortOrder: obj.sortOrder ? obj.sortOrder : obj.sort.order,
      page: obj.page || 1,
      take: obj.take || 10
    };
  };

  fetchNewRequestList(customParams = {}) {
    const {
      DashBoardStore: {
        NewRequestDashBoardList: { params }
      }
    } = this.props;

    let data = this.objToParams(Object.assign(params, customParams));
    this.props.getNewRequestList({
      data
    }, () => this.setState({isLoading: true}));
  }

  refreshList(params) {
    this.setState(
      {
        defaultSortName: params.defaultSortName,
        defaultSortOrder: params.defaultSortOrder,
        currentPage: params.currentPage,
        sizePerPage: params.sizePerPage
      },
      () => {
        let urlParams = queryString.parse(this.props.location.search);
        urlParams['searchKey'] = this.state.searchTxt.trim();
        urlParams['sortField'] = params.defaultSortName;
        urlParams['sortOrder'] = params.defaultSortOrder;
        urlParams['page'] = params.currentPage;
        urlParams['take'] = params.sizePerPage;
        urlParams = pickBy(urlParams);

        this.props.history.push({
          search: queryString.stringify(urlParams)
        });
      }
    );
  }

  customRenderRFS(item) {
    return (
      <span>
        <Link to={`/request-for-services/${item.refNo}`}>{item.refNo}</Link>
      </span>
    );
  }

  renderNewRequestFromHomeowners = () => {
    const {column, defaultSortName, defaultSortOrder, sizePerPage, totalRecord, currentPage, isDisplayTable} = this.state;
    const data = this.props.DashBoardStore.NewRequestDashBoardList.items;
    const options = {
      defaultSortName,
      defaultSortOrder,
      sizePerPage,
      totalRecord,
      currentPage
    };
    return (
      <React.Fragment>
        <div className='new-request-from-homeowner box-form-siteone clearfix'>
          <h4>New requests from homeowners ({this.props.DashBoardStore.NewRequestDashBoardList.params.totalRecord})</h4>
          <div className='new-request-table'>
            <TableList
              ref={ref => {
                this.tableList = ref;
              }}
              column={column}
              defaultParams={defaultParams}
              data={data}
              options={options}
              refreshPageList={this.refreshList.bind(this)}
              refreshList={this.refreshList.bind(this)}
              applySkeleton={true}
              isDisplayTable={isDisplayTable}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderSkeleton = () => {
    return (
      <SkeletonTheme color='#efe6e6'>
        <Skeleton count={1} style={{ height: 655, margin: '10px 0px 0px'}} />
      </SkeletonTheme>
    );
  }

  render() {
    const {isLoading} = this.state;
    return (
      <React.Fragment>
        {isLoading === false ? this.renderSkeleton() : this.renderNewRequestFromHomeowners()}
      </React.Fragment>
    );
  }
}

export default NewRequestFromHomeownerTable;



// WEBPACK FOOTER //
// ./src/Dashboard/Components/new-request-from-homeowners-table.js